import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default () => ({
	open: null,
	init() {
		this.resize();
		const swiperContainer = this.$root.querySelector(".swiper");
		const swiper = new Swiper(swiperContainer, {
			modules: [Navigation, Pagination],
			slidesPerView: 1,
			spaceBetween: 20,
			breakpoints: {
				1024: {
					slidesPerView: 1.2,
					pagination: {
						enabled: false,
					},
				},
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			pagination: {
				enabled: true,
				el: ".swiper-pagination",
			},
		});
	},
	resize() {
		let container = document.querySelector(".container");
		let containerWidth = container.getBoundingClientRect().width;
		let space = ((window.outerWidth - containerWidth) / 2) - this.getScrollBarWidth();

		// if (Math.ceil(space) < 21) {
		// 	space = 21;
		// }
		this.$root.style.paddingLeft = Math.ceil(space) + "px";
	},
	getScrollBarWidth() {
		let el = document.createElement("div");
		el.style.cssText =
			"overflow:scroll; visibility:hidden; position:absolute;";
		document.body.appendChild(el);
		let width = el.offsetWidth - el.clientWidth;
		el.remove();
		return width;
	},
});
